import _startCase from 'lodash/startCase';
export function getFinalDestinationEmail(destinationEmail, getDestinationEmail) {
  var finalDestinationEmail = destinationEmail;
  if (!destinationEmail && getDestinationEmail) {
    finalDestinationEmail = getDestinationEmail();
  }
  return finalDestinationEmail;
}
export function createDefaultMessageFromState(fields) {
  return Object.keys(fields).map(function (key) {
    return "".concat(_startCase(key), ": ").concat(fields[key]);
  }).join('\n');
}